import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import type { UserInfo } from '@/services/api/lake'

/** Superuser / inactive status badges for a user. `size` tunes the scale for
 *  the compact list row vs the larger detail header. */
export function UserBadges({ user, size = 'sm' }: { user: UserInfo; size?: 'sm' | 'md' }) {
  const { t } = useTranslation()
  const sup = size === 'sm' ? 'text-[9px] px-1.5 py-0' : 'text-[10px]'
  const inact = size === 'sm' ? 'text-[9px] px-1.5 py-0' : 'text-[10px]'
  return (
    <>
      {user.is_superuser && (
        <Badge
          variant="outline"
          className={`bg-warning-surface text-warning-foreground border-warning-border uppercase tracking-wider ${sup}`}
        >
          {size === 'sm' ? t('admin.users.super') : t('common.superuser')}
        </Badge>
      )}
      {!user.is_active && (
        <Badge
          variant="outline"
          className={`bg-destructive-surface text-destructive-foreground border-destructive-border ${inact}`}
        >
          {size === 'sm' ? t('admin.users.inactive') : t('common.inactive')}
        </Badge>
      )}
    </>
  )
}
